export const taskManagerTrackingIDs = {
    taskManagerListItem: {
        id: 'dagligbank-task-manager',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFza01hbmFnZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvZ3RtL3RyYWNrSURzL3Rhc2tNYW5hZ2VyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBQyxNQUFNLHNCQUFzQixHQUFHO0lBQ2xDLG1CQUFtQixFQUFFO1FBQ2pCLEVBQUUsRUFBRSx5QkFBeUI7S0FDaEM7Q0FDSixDQUFDIn0=